import { Component, ErrorInfo, ReactNode } from 'react';
import { getParams } from '@/utils/params';
import { trackError } from '@/utils/raygun';
import { clearMemento } from '@/redux/draft/memento/clearMemento';
import './ErrorBoundary.scss';

interface Props {
  children: ReactNode;
}

interface State {
  error?: Error;
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {};
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    this.setState({ error });
    trackError(error, { errorInfo });
    const { contextId, platform } = getParams();
    clearMemento(contextId, platform);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="error-boundary">
          <h2>Something went wrong, apologies.</h2>
          {this.state.error.message && <h3>{this.state.error.message}</h3>}
          <p>
            We track these errors automatically.
            <br />
            Please reload this page. If the problem persists feel free to contact us.
            <br />
          </p>
        </div>
      );
    }
    return this.props.children;
  }
}
